export default "__VITE_ASSET__COlN14lI__"